import React from 'react'
import {Divider, Dropdown, Grid} from 'semantic-ui-react'
import {budgetMonthsURL} from "../../shared/urls/clientapi";
import {callService, GET} from "../../shared/serviceInvoker";
import Budget from "../Budget/index";
import BudgetMonthly from "../BudgetMonthly/index";

export default class DropdownBudgetType extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: 'crm',
      budgetType: <Budget />
    };
  }

  onChange = (e, data) => {
    let selectedBudgetType = <Budget />;
    if (data.value !== 'crm') {
      selectedBudgetType = <div key={data.value}>
        <BudgetMonthly
          selected_budget_type={data.value}
        />
      </div>
    }

    this.setState({
      selected: data.value,
      budgetType: selectedBudgetType
    });
  };

  componentDidMount = () => {
    this.props.updatenav("budget");

    let contactId = "";
    if (sessionStorage.getItem("contact_id")) {
      contactId = sessionStorage.getItem("contact_id");
    }

    callService(
      GET,
      budgetMonthsURL.replace('{contact_id}', contactId),
      null,
      response => {
        let result = response.data.data;
        let monthOptions = [];
        monthOptions.push({ key: 1, text: 'General', value: 'crm' });
        for (let i = 0; i < result.length; i++) {
          monthOptions.push({ key: i + 2, text: result[i], value: '\'' + result[i] + '\'' })
        }
        this.setState({
          monthOptions: monthOptions
        });
      },
      error => {
        this.setState({
          error: true
        });
      }
    );

  };

  render() {
    const { selected, budgetType, monthOptions } = this.state;
    return (
      <div>
        <Divider hidden />
        <Grid stackable>
          <Grid.Column width={4} className='grid-padding'>
            <Dropdown
              name='bud'
              button
              className='icon'
              fluid
              labeled
              icon='caret square down outline'
              options={monthOptions}
              value={selected}
              onChange={this.onChange}
            />
          </Grid.Column>
        </Grid>

        {budgetType}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BudgetDropdown/index.js